import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})

export class VerifyComponent implements OnInit {
  public emailHash:string;
  public error:string;
  public success:boolean=false;
  public needsExtra:boolean=false;
  public password:string='';
  public confirm_password:string='';
  public registrationComplete:boolean=false;
  // TimeZone
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;

  constructor(
    private _route: ActivatedRoute,
    private _auth: AuthenticationService,
    private _router: Router,
    private timezoneService: TimeZoneService
  ) {
    this._route.params.subscribe(res=>{
      this.emailHash=res.emailHash;
    });
  }

  public completeRegistration(){
    if(this.password.length < 8 || this.confirm_password.length < 8) {
      return this.error="Password must be at least 8 characters in length.";
    }
    if(this.password != this.confirm_password) {
      return this.error="Passwords do not match.";
    }
    this._auth.completePracticeRegistered(this.emailHash, this.password).subscribe(res=>{
      if(res.message=='success'){
        this.registrationComplete=true;
      }
    });
  }

  public verifyEmail(){
    this._auth.verifyEmail(this.emailHash).subscribe(res=>{
      if (res.error) {
        this.error=res.error;
      } else {
        this.success=true;
      }
    });
  }

  public testForPracticeRegistered(){
    this._auth.testForPracticeRegistered(this.emailHash).subscribe(res=>{
      if (res.practiceRegistered) {
        this.needsExtra=true;
      } else {
        this.verifyEmail();
      }
    });
  }

  private redirectoToLogin(){
    this._router.navigate(['/login']);
  }

  ngOnInit() {
    setTimeout(()=>{
      this.testForPracticeRegistered();
    }, 2000);
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
  }

}
